var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.featureDiscoveryEnabled
    ? _c("generic-modal", {
        attrs: {
          id: "application-feature-discovery-modal",
          "modal-dialog-scrollable": false,
          "loaders-disabled": "",
          "modal-class": "account-plan-message-modal",
        },
        on: { hidden: _vm.handleHidden },
        scopedSlots: _vm._u(
          [
            {
              key: "header-custom",
              fn: function () {
                return [
                  _c("h4", { staticClass: "modal-title bold text-white" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "global.applicationFeatureDiscovery.modal.title"
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "body",
              fn: function () {
                return [
                  _c("i18n", {
                    attrs: {
                      path: "global.applicationFeatureDiscovery.modal.bodyText.0",
                      tag: "p",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "link",
                          fn: function () {
                            return [
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-primary bold clickable",
                                  attrs: {
                                    to: {
                                      path: "/personal-settings/account/filogix-details",
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "settings.accountTab.lenderSubmissionDetails"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                  _c("icon", {
                                    attrs: { name: "external-link" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3239801169
                    ),
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "global.applicationFeatureDiscovery.modal.bodyText.1"
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticClass: "list-style-disc" },
                    _vm._l(_vm.erdPerks, function (index) {
                      return _c("i18n", {
                        key: index,
                        attrs: {
                          path:
                            "global.applicationFeatureDiscovery.modal.featureList." +
                            (index - 1),
                          tag: "li",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "link",
                              fn: function () {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "text-primary bold clickable",
                                      attrs: {
                                        to: {
                                          path: "/personal-settings/account/filogix-details",
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t(
                                              "settings.accountTab.lenderSubmissionDetails"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                      _c("icon", {
                                        attrs: { name: "external-link" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("i18n", {
                    staticClass: "m-0",
                    attrs: {
                      path: "global.applicationFeatureDiscovery.modal.releaseNotesLink",
                      tag: "p",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "clickHereSection",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary clickable bold",
                                  on: { click: _vm.closeAndOpenReleaseNotes },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "settings.notificationsTab.notificationsText.releaseNotes.label"
                                        )
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4035045076
                    ),
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3168286360
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }